<template>
  <autocomplete
    item-value="id"
    item-text="nome"
    :items="categorie"
    :loading="loading"
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"/>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'CategorieProdottiSelect',
    props: {
        value: { required: false },
        showDismessi: Boolean
    },
    created () {
        this.$store.dispatch('loadCategorieProdotti').catch(e => {
            this.$snackbar.showServerError(e)
        })
    },

    computed: {
        ...mapState({
            items: state => state.global.categorieProdotti,
            loading: state => state.global.loading.categorieProdotti
        }),

        categorie () {
            let categorie = this.items
            if (this.showDismessi) {
                categorie = categorie.concat({ id: -1, nome: this.$t('prodotti.label.dismessi') })
            }
            return categorie
        }
    }
}
</script>
